export default __webpack_public_path__ + "static/media/ulu_description.d9b51d57.png";